import React, { useEffect, useState } from 'react';
import Panel from 'Components/Panel/Panel';
import ExecuteAxios from 'Components/ExecuteAxios/ExecuteAxios';
import OptionsDataByAttributePath from 'Components/Options/optionsData/OptionsDataByAttributePath';
import ComboBox from 'Components/ComboBox/ComboBox';
import 'react-datepicker/dist/react-datepicker.css';
import LoadingIndicator from 'Components/LoadingIndicator/LoadingIndicator';
import ReactDataPickerComp from 'Components/ReactDataPicker/ReactDataPickerComp';
import MandatoryIconField from 'Components/MandatoryIconField';

const firstDayOfMonth = (date) => {
    const reference = date || new Date();
    return new Date(reference.getFullYear(), reference.getMonth(), 1);
}

const lastDayOfMonth = (date) => {
    const reference = date || new Date();
    return new Date(reference.getFullYear(), reference.getMonth() + 1, 0);
}

const SchedulePanel = (
    {
        onUpdateSectorSelected,
        onUpdateResetFilterDay,
        sectorSelected,
        selectedActualDate,
        sectors
    }) => {
    const [inserting, setInserting] = useState()
    const [dataStartSelected, setDataStartSelected] = useState(() => firstDayOfMonth(selectedActualDate));
    const [dataFinishSelected, setDataFinishSelected] = useState(() => lastDayOfMonth(selectedActualDate));
    const [roleSelected, setRoleSelected] = useState(null);
    const [loadingHourPanel, setLoadingHourPanel] = useState(false);
    const [externalEmployeeSelected, setExternalEmployeeSelected] = useState(null);

    const [roles, setRoles] = useState(null);
    const [externalEmployees, setExternalEmployees] = useState([]);

    const sectorOptions = OptionsDataByAttributePath(sectors, ['description'], null, true)
    const rolesOptions = OptionsDataByAttributePath(roles, ['role'], null, true);
    const externalEmployeesOptions = OptionsDataByAttributePath(externalEmployees, ['description'], null, true)

    useEffect(() => {
        callToSetRoles()
    }, []);

    useEffect(() => {
        setDataStartSelected(firstDayOfMonth(selectedActualDate));
        setDataFinishSelected(lastDayOfMonth(selectedActualDate));
    }, [selectedActualDate]);

    async function callToSetRoles() {
        try {
            setRoles(await ExecuteAxios.api('get', `/employee/lookup-role`))
        } catch (error) {
            console.log(error)
        }
    }

    useEffect(() => {
        setExternalEmployees(null)
        callToSetExternalsUsers()
    }, [roleSelected, sectorSelected]);

    async function callToSetExternalsUsers() {
        const parameters = {
            sectorId: sectorSelected,
            roleId: roleSelected,
        };

        try {
            setExternalEmployees(await ExecuteAxios.api('get', `/employee/get-employees-external-list/`, { params: parameters }))
        } catch (error) {
            console.log(error)
        }
    }

    async function newPeriodCalendar() {
        try {
            setLoadingHourPanel(true)
            const response = await ExecuteAxios.api('post', `/employee-hours-available/`, {
                sectorId: sectorSelected,
                roleId: roleSelected,
                externalEmployee: externalEmployeeSelected,
                startDateSelected: dataStartSelected,
                endDateSelected: dataFinishSelected
            });
            if (response) {
                onUpdateResetFilterDay(true);
            }

            return response;
        } finally {
            setLoadingHourPanel(false)
        }
    }

    function resetVariables() {
        setDataStartSelected(firstDayOfMonth(selectedActualDate));
        setDataFinishSelected(lastDayOfMonth(selectedActualDate));
        setRoleSelected(null);
        setExternalEmployeeSelected(null);
    }

    const PanelSchedule = {
        display: 'flex',
        width: '100%',
    };

    const PanelScheduleAttributes = {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        marginTop: '1%'
    };

    const styleAttribute = {
        display: 'flex',
        flexDirection: 'row',
    };

    const detailAtributesStyle = {
        display: 'flex',
        flexDirection: 'column',
        width: '48%',
        margin: '1%'
    };

    const readOnlyAttributes = !inserting;

    return (
        <Panel style={PanelSchedule}>
            <Panel
                titlePage={'Geração do planejamento'}
                style={PanelScheduleAttributes}
                canViewCRUD={true}
                enableNewRecord={true}
                canNewRecord={true}
                canSaveAfterNewRecord={sectorSelected && dataStartSelected && dataFinishSelected}
                setInserting={setInserting}
                postFunction={newPeriodCalendar}
                recordsSelected={[]}
                inserting={inserting}
                resetVariables={resetVariables}
                cancelFunction={resetVariables}
            >
                <LoadingIndicator loaded={!loadingHourPanel}>
                    <Panel style={styleAttribute}>
                        <div style={detailAtributesStyle}>
                            <div style={{ display: 'flex', flexDirection: 'row' }}>
                                <span>Setor</span>
                                <MandatoryIconField />
                            </div>
                            <ComboBox setAttribute={onUpdateSectorSelected}
                                optionsData={sectorOptions}
                                value={sectorSelected}
                                defaultValue={sectorSelected}
                                readOnly={readOnlyAttributes}
                                disabled={readOnlyAttributes}
                            />
                        </div>
                        <div style={detailAtributesStyle}>
                            <div style={{ display: 'flex', flexDirection: 'row' }}>
                                <span>Cargo</span>
                            </div>
                            <ComboBox setAttribute={setRoleSelected}
                                optionsData={rolesOptions}
                                value={roleSelected}
                                defaultValue={roleSelected}
                                readOnly={readOnlyAttributes}
                                disabled={readOnlyAttributes}
                            />
                        </div>
                        {/*<div style={detailAtributesStyle}>
                            <span>Usuário externo</span>
                            <ComboBox setAttribute={setExternalEmployeeSelected}
                                optionsData={externalEmployeesOptions}
                                value={externalEmployeeSelected}
                                defaultValue={externalEmployeeSelected}
                                readOnly={readOnlyAttributes}
                                disabled={readOnlyAttributes}
                            />
                        </div>*/}
                    </Panel>
                    <div style={{ display: 'flex', flexDirection: 'row', width: '100%' }}>
                        <div style={{ display: 'flex', flexDirection: 'column', margin: '1%', width: '50%' }}>
                            <div style={{ display: 'flex', flexDirection: 'column', marginBottom: '1%' }}>
                                <div style={{ display: 'flex', flexDirection: 'row' }}>
                                    <label>Data inicial:</label>
                                    <MandatoryIconField />
                                </div>

                                <ReactDataPickerComp
                                    selected={dataStartSelected}
                                    onChange={(date) => { setDataStartSelected(date) }}
                                    wrapperClassName={'width-full'}
                                    className='validate-attribute width-full cursor-pointer'
                                    dateFormat="dd/MM/yyyy"
                                    readOnly={readOnlyAttributes}
                                    setter={setDataStartSelected}
                                />
                            </div>
                        </div>
                        <div style={{ display: 'flex', flexDirection: 'column', margin: '1%', width: '50%' }}>
                            <div style={{ display: 'flex', flexDirection: 'column', marginBottom: '1%' }}>
                                <div style={{ display: 'flex', flexDirection: 'row' }}>
                                    <label>Data Final:</label>
                                    <MandatoryIconField />
                                </div>
                                <ReactDataPickerComp
                                    selected={dataFinishSelected}
                                    onChange={(date) => { setDataFinishSelected(date) }}
                                    wrapperClassName={'width-full'}
                                    className='validate-attribute width-full cursor-pointer'
                                    dateFormat="dd/MM/yyyy"
                                    readOnly={readOnlyAttributes}
                                    setter={setDataFinishSelected}
                                />
                            </div>
                        </div>
                    </div>
                </LoadingIndicator>
            </Panel >
        </Panel >
    )
};

export default SchedulePanel;
